"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIGeofence = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "isIGeofence", { enumerable: true, get: function () { return iotv_v3_types_1.isIGeofence; } });
